import React, { useState } from 'react';
import Container from '@src/components/reusable/Container';
import { AppName, HeaderContainer, LogoContainer, Title } from './styles';
import { App } from '@src/core/buyerApiClient';

type HeaderProps = {
  title: string;
  app?: App;
};

export const Header = (props: HeaderProps) => {
  const { title, app } = props;

  const [imageError, setImageError] = useState(false);

  return (
    <HeaderContainer>
      <Container>
        {app?.logoUrl && app?.logoUrl !== '' && !imageError ? (
          <LogoContainer>
            <img
              src={app?.logoUrl}
              alt={app?.name}
              onError={() => {
                setImageError(true);
              }}
            />
          </LogoContainer>
        ) : (
          <AppName>{app?.name}</AppName>
        )}

        <Title>{title}</Title>
      </Container>
    </HeaderContainer>
  );
};

export default Header;
